import { StyledFooter, StyledFooterSection, StyledSocialMedia } from "./style";
import instagram from "../res/icons/instagram_gradient.png";
import facebook from "../res/icons/facebook.png";

export const Footer = ({ setModalDialog }) => {
  return (
    <StyledFooter>
      <div class="footer-section">
        <div>© 2025 Jennifer Bauer</div>
        <a href="mailto:info@jenni-hairmakeup.de">info@jenni-hairmakeup.de</a>
      </div>
      <div class="footer-section">
        <a onClick={() => setModalDialog("legal")}>Impressum</a>
      </div>
      <StyledFooterSection>
        <StyledSocialMedia>
          <p>Social Media:</p>
          <a
            href="https://www.facebook.com/pg/jenni_hairmakeup-106327034727372"
            target="_blank"
            rel="noreferrer"
          >
            <img src={facebook} width="36px" alt="Instagram" />
          </a>
          <a
            href="https://www.instagram.com/jenni_hair.makeup/"
            target="_blank"
            rel="noreferrer"
          >
            <img src={instagram} width="36px" alt="Instagram" />
          </a>
        </StyledSocialMedia>
      </StyledFooterSection>
    </StyledFooter>
  );
};
